import type { CellContext } from "@msuite/ui/table";
import type { FileInboxListItem } from "@msuite/utils/types";
import { FileRowActions } from "@/components/files";

/**
 * The inbox row's menu, which is the shared one every unfiled file carries.
 *
 * No `onNavigate`: this page is a route, so the offer import's jump to the editor unmounts it and
 * the menu with it. The batch report, which is mounted above the routes, has to be told.
 */
export function RowActions({ cell }: CellContext<FileInboxListItem, "actions">) {
	/** Computed */
	const item = cell.row.original;

	/** Render */
	return (
		<FileRowActions
			file={item.file}
			candidates={item.candidates}
			documentKind={item.documentKind}
		/>
	);
}
